import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('./modules/login/Login.vue'),
    },

    {
      path: '/',
      component: () => import('./layout/Layout.vue'),
      children: [
        {
          path: '/imobiliarias',
          name: 'imobiliarias',
          component: () => import('./modules/imobiliarias/Imobiliarias.vue'),
        },
        {
          path: '/cadastro',
          component: () => import('./modules/cadastro/Cadastro.vue'),
          children:[
            {
              path: 'imobiliaria',
              name: 'imobiliariasPreCadastradas',
              component: () => import('./modules/cadastro/imobiliaria/ImobiliariaPreCadastrada.vue'),
            },
            {
              path: 'bairro',
              name: 'bairro',
              component: () => import('./modules/cadastro/bairro/Bairros.vue')
            },
            {
              path: 'cidade',
              name: 'cidade',
              component: () => import('./modules/cadastro/cidade/Cidades.vue')
            },
            {
              path: '/caracteristicas',
              component:() => import('./modules/cadastro/caracteristicas/Caracteristicas.vue'),
              children: [
                {
                  path: 'condominio',
                  name: 'condominio',
                  component:() => import('./modules/cadastro/caracteristicas/condominio/Condominio.vue')
                },
                {
                  path: 'imovel',
                  name: 'imovel',
                  component:() => import('./modules/cadastro/caracteristicas/imovel/Imovel.vue')
                }
              ]
            }
          ]
        }
      ],
    },

    { 
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  if(to.path == "/") { next(); return; }

  if(store.state.loginStore.usuarioLogado.id) {
    next();
  } else {
    next("/");
  }
});

export default router;